// eslint-disable-next-line no-unused-vars
import qs from 'querystring';

const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  fetchList: ({ commit }) => {
    const fakeData = [
      { id: 1, school: 'SMKN 13 BANDUNG', city: 'Bandung', province: 'West java' },
      { id: 2, school: 'SMAN 24 BANDUNG', city: 'Bandung', province: 'West java' },
      { id: 3, school: 'SMAN 1 JAKARTA', city: 'Jakarta', province: 'Jakarta' },
      { id: 4, school: 'SMAN 3 BANDUNG', city: 'Bandung', province: 'West java' },
      { id: 5, school: 'SMAN 5 JAKARTA', city: 'Jakarta', province: 'Jakarta' }
    ];
    commit('SET_ITEM', fakeData);
    return Promise.resolve();
  }

  // fetchList: ({ commit, rootGetters }, { course, arrangeBy }) => {
  //   const defaultPageable = rootGetters['table/defaultPageable'];
  //   const queryParams = {
  //     limit: defaultPageable.limit,
  //     page: defaultPageable.currentPage - 1,
  //     search: defaultPageable.search,
  //     course,
  //     arrangeBy
  //   };

  //   return window.axios
  //     .get('', {
  //       params: queryParams,
  //       paramsSerializer: function(params) {
  //         return qs.stringify(params);
  //       }
  //     })
  //     .then(response => {
  //       let data = response.data.data;
  //       commit('SET_ITEM', data.content);
  //       commit('table/SET_DEFAULT_TOTAL_PAGES', data.totalPages, { root: true });
  //       commit('table/SET_DEFAULT_TOTAL_ELEMENTS', data.totalElements, { root: true });
  //       return data;
  //     })
  //     .catch(error => {
  //       throw error;
  //     });
  // }
};

export default { namespaced, state, getters, mutations, actions };
